import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';
import { store } from '../configureStore';

export const fetchAllMenuItems = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .fetchAllMenuItems(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_MENU_ITEMS_FAILED,
              reject: actionTypes.FETCH_ALL_MENU_ITEMS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_MENU_ITEMS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_MENU_ITEMS_SUCCESS, res);

  return request();
};

export const changeMenuItemActivity = (id, isActive) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .changeMenuItemActivity(id, isActive)
        .then(() => {
          const { menuItemsList } = store.getState().menuItemsReducer;
          const index = menuItemsList.findIndex(item => item.id === id);
          const updateList = [...menuItemsList];
          updateList[index] = {
            ...updateList[index],
            isActive: isActive,
          };
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CHANGE_MENU_ITEM_STATUS_FAILED,
              reject: actionTypes.CHANGE_MENU_ITEM_STATUS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CHANGE_MENU_ITEM_STATUS_LOADING);
  const success = res =>
    action(actionTypes.CHANGE_MENU_ITEM_STATUS_SUCCESS, res);

  return request();
};

export const fetchAllDeletedMenuItems = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .fetchAllDeletedMenuItems(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_FAILED,
              reject: actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_SUCCESS, res);

  return request();
};

export const deleteMenuItem = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .deleteMenuItem(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DELETE_MENU_ITEM_FAILED,
              reject: actionTypes.DELETE_MENU_ITEM_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DELETE_MENU_ITEM_LOADING);
  const success = res => action(actionTypes.DELETE_MENU_ITEM_SUCCESS, res);

  return request();
};

export const fetchMenuItemById = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .fetchMenuItemById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_MENU_ITEM_BY_ID_FAILED,
              reject: actionTypes.FETCH_MENU_ITEM_BY_ID_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_MENU_ITEM_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_MENU_ITEM_BY_ID_SUCCESS, res);

  return request();
};

export const insertNewMenuItem = itemObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .insertNewMenuItem(itemObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.INSERT_NEW_MENU_ITEM_FAILED,
              reject: actionTypes.INSERT_NEW_MENU_ITEM_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.INSERT_NEW_MENU_ITEM_LOADING);
  const success = res => action(actionTypes.INSERT_NEW_MENU_ITEM_SUCCESS, res);

  return request();
};

export const updateMenuItem = itemObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .updateMenuItem(itemObject)
        .then(res => {
          const { menuCategories } = store.getState().menuCategoriesReducer;
          const { menuItemsList } = store.getState().menuItemsReducer;
          const index = menuItemsList.findIndex(
            item => item.id === itemObject.id,
          );
          const categoryIndex = menuCategories.menuCategories.findIndex(
            item => item.id === itemObject.menuCategoryId,
          );
          const menuCategoryTitle =
            menuCategories.menuCategories[categoryIndex].title;
          // const imageUrl = `${ASSET_ENDPOINT}${itemObject.imageFileName}`;
          const imageUrl = `${ASSET_ENDPOINT}uploads/menuItems/${itemObject.imageFileName}`;
          const updateList = [...menuItemsList];
          updateList[index] = {
            ...itemObject,
            createdFullName: updateList[index].createdFullName,
            createdAt: updateList[index].createdAt,
            createdBy: updateList[index].createdBy,
            currency: updateList[index].currency,
            menuCategoryTitle: menuCategoryTitle,
            imageUrl: imageUrl,
          };
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_MENU_ITEM_FAILED,
              reject: actionTypes.UPDATE_MENU_ITEM_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_MENU_ITEM_LOADING);
  const success = res => action(actionTypes.UPDATE_MENU_ITEM_SUCCESS, res);

  return request();
};

export const getMenuItemsImages = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuItems
        .getMenuItemsImages()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_MENU_ITEM_IMAGES_FAILED,
              reject: actionTypes.GET_MENU_ITEM_IMAGES_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_MENU_ITEM_IMAGES_LOADING);
  const success = res => action(actionTypes.GET_MENU_ITEM_IMAGES_SUCCESS, res);

  return request();
};
